module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/breadcrumb/breadcrumb.component.scss
// module id = ./src/app/features/typography/breadcrumb/breadcrumb.component.scss
// module chunks = main